define.alias("shared/components/shared/social-identity/info", "preview-grid/components/shared/social-identity/info");